export const ADMIN_TOKEN_COOKIE = 'admin_token';
